import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import CloseIcon from 'material-ui-icons/Close'
import { closeNotification } from '../modules/notifications'
import { connect } from 'react-redux'
import IconButton from 'material-ui/IconButton'
import Messages from '../constants/messages'
import { Route } from 'react-router-dom'
import Snackbar from 'material-ui/Snackbar'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  app: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  closeNotification: PropTypes.func.isRequired,
  notificationMessage: PropTypes.string,
  showNotification: PropTypes.bool.isRequired
}

const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    zIndex: 1
  },
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  }
})

export class CoreLayout extends Component {

  renderNotificationMessage() {
    const { app, notificationMessage } = this.props
    const systemErrorPattern = /^\[PA.*]/g
    let message = notificationMessage

    if (systemErrorPattern.test(message)) {
      let contactInfo = app.email ? app.email : Messages['notificationMessages']['ADMIN_EMAIL']
      message = message + contactInfo
    }

    return <span id="message-id">{message}</span>
  }

  render() {
    const {
      classes,
      closeNotification,
      component,
      notificationMessage,
      showNotification,
      ...rest
    } = this.props
    const Component = this.props.component

    return (
      <Route {...rest} render={matchProps => (
        <section className={classes.root}>
          <Component {...matchProps} />
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={showNotification}
            onRequestClose={closeNotification}
            SnackbarContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={this.renderNotificationMessage()}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={closeNotification}>
                <CloseIcon />
              </IconButton>
            ]}
          />
        </section>
      )} />
    )
  }
}

CoreLayout.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  app: state.appContext.appInfo,
  showNotification: state.notifications.showNotification,
  notificationMessage: state.notifications.message,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeNotification: closeNotification
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CoreLayout)
